import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "../../../components/shared/Sidebar";
import Topbar from "../../../components/shared/Topbar";

const NAV_ITEMS = [
  { label: "Dashboard", path: "/lab", end: true, icon: "📊" },
  { label: "Profile", path: "/lab/profile", icon: "🏢" },
  { label: "Test Catalogue", path: "/lab/test-catalogue", icon: "📋" },
  { label: "Bookings", path: "/lab/bookings", icon: "📅" },
  { label: "Schedule", path: "/lab/schedule", icon: "🗓️" },
];

const PAGE_TITLES = {
  "/lab": "Dashboard",
  "/lab/profile": "Lab Profile",
  "/lab/test-catalogue": "Test Catalogue",
  "/lab/bookings": "Bookings",
  "/lab/schedule": "Schedule",
};

export default function LabLayout() {
  const { pathname } = useLocation();
  const title =
    Object.entries(PAGE_TITLES).find(([key]) => pathname === key)?.[1] ||
    "Lab Portal";

  return (
    <div className="flex min-h-screen bg-slate-50">
      <Sidebar logo="🧪" title="Lab Portal" navItems={NAV_ITEMS} />
      <div className="flex-1 flex flex-col overflow-hidden">
        <Topbar title={title} />
        <main className="flex-1 overflow-y-auto p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
